import { RbacRole } from '@goodneighbor/db/index';

export const accountHasRoles = ({
  account,
  requiredRoles,
  operation
}: {
  account?: {
    data: {
      roles: RbacRole[] | null;
    };
  } | null | void;
  requiredRoles: RbacRole[];
  operation?: 'AND' | 'OR';
}) => {
  if (!account?.data?.roles) {
    return false;
  }
  return hasRoles({
    roles: account.data.roles,
    requiredRoles,
    operation
  });
};

export const hasRoles = ({
  roles,
  requiredRoles,
  operation
}: {
  roles: RbacRole[] | null;
  requiredRoles: RbacRole[];
  operation?: 'AND' | 'OR';
}) => {
  if (!roles) {
    return false;
  }
  if (requiredRoles.length === 0) {
    return false;
  }
  if (operation === 'OR') {
    return requiredRoles.some((requiredRole) => roles.includes(requiredRole));
  }
  // Default to 'AND' operation
  return requiredRoles.every((requiredRole) => roles.includes(requiredRole));
};
